import { ref } from "vue";
import type { Socket } from "socket.io-client";

// default true so the banner only shows on real disconnects, not pre-auth
export const socketConnected = ref(true);

const trackedRooms = new Set<string>();

type JoinAck = { ok: boolean; reason?: string };

function emitJoin(socket: Socket, room: string, onAck?: (ack: JoinAck) => void) {
  socket.emit("join", { room }, (ack?: JoinAck) => {
    if (!ack) return;
    if (!ack.ok && process.env.NODE_ENV === "development") {
      console.warn(`[socket] join rejected for room "${room}":`, ack.reason);
    }
    onAck?.(ack);
  });
}

export function joinRoom(socket: Socket, room: string, onAck?: (ack: JoinAck) => void): void {
  trackedRooms.add(room);
  emitJoin(socket, room, onAck);
}

export function leaveRoom(socket: Socket, room: string): void {
  trackedRooms.delete(room);
  socket.emit("leave", { room });
}

export function rejoinAll(socket: Socket): void {
  for (const room of trackedRooms) emitJoin(socket, room);
}

// call on logout so a fresh login doesn't rejoin stale rooms
export function clearTrackedRooms(): void {
  trackedRooms.clear();
}
